import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords = 'architecture, architectural design, construction, building design, building planning, interior design, modular kitchen, modular kitchen interior design, kitchen design, modern kitchen design, 2D & 3D interior design, residential interior design, commercial interior design, space planning, turnkey projects',
  image = '/og-image.jpg',
  url,
  type = 'website'
}) => {
  const siteTitle = 'Braj Decor And Designers Architect - Professional Architecture & Design Services';
  const fullTitle = title === 'Home' ? siteTitle : `${title} | Braj Decor And Designers Architect`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      {url && <meta property="og:url" content={url} />}
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Braj Decor And Designers Architect" />
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;